<template>
  <Dialog v-model:visible="dialogVisible" modal header="Seleziona provider" :style="{ width: '30rem' }" :breakpoints="{ '575px': '90vw' }">
    <label :for="inputId">Provider</label>
    <Dropdown :inputId="inputId" v-model="selectedProvider" :options="downloadProviders" optionLabel="name" optionValue="name" placeholder="Seleziona provider" class="w-full mt-2 uppercase" :filter="true" optionDisabled="disabled" :disabled="loadingProviders || loading" />
    <small v-if="loadingProviders" class="block mt-2">Caricamento provider...</small>
    <small v-if="providerError" class="p-error block mt-2" role="alert">{{ providerError }}</small>
    <template #footer>
      <Button label="Annulla" class="p-button-text" @click="dialogVisible = false" />
      <Button :label="confirmLabel" icon="pi pi-download" :disabled="!selectedProvider || loadingProviders || loading" @click="confirmSelection" />
    </template>
  </Dialog>
</template>

<script>
import { computed, ref, watch } from 'vue';
import Service from '@/services/ask-pratiche/gestione-pratiche';

export default {
  props: {
    visible: { type: Boolean, default: false },
    supplyType: { type: String, required: true, validator: value => ['pod', 'pdr'].includes(value) },
    loading: { type: Boolean, default: false },
    confirmLabel: { type: String, default: 'Scarica file' },
    inputId: { type: String, default: 'selection-provider' },
  },
  emits: ['update:visible', 'confirm'],
  setup(props, { emit }) {
    const dialogVisible = computed({
      get: () => props.visible,
      set: value => emit('update:visible', value),
    });
    const service = new Service();
    const selectedProvider = ref(null);
    const downloadProviders = ref([]);
    const loadingProviders = ref(false);
    const providerError = ref('');

    watch(() => [props.visible, props.supplyType], async ([visible, supplyType], previous, onCleanup) => {
      let active = true;
      onCleanup(() => { active = false; });
      selectedProvider.value = null;
      downloadProviders.value = [];
      providerError.value = '';
      loadingProviders.value = false;
      if (!visible) return;

      loadingProviders.value = true;
      try {
        const templates = await service.getTemplatesAvailable();
        if (active) downloadProviders.value = templates[supplyType].filter(provider => !provider.disabled);
      } catch (error) {
        if (active) providerError.value = 'Impossibile caricare i provider disponibili. Chiudi e riapri la selezione per riprovare.';
      } finally {
        if (active) loadingProviders.value = false;
      }
    }, { immediate: true });

    const confirmSelection = () => {
      if (selectedProvider.value && !loadingProviders.value && !props.loading) emit('confirm', selectedProvider.value);
    };

    return { dialogVisible, selectedProvider, downloadProviders, loadingProviders, providerError, confirmSelection };
  },
};
</script>
